export const FETCH_ASSET_STATS = 'FETCH_ASSET_STATS';
export const RESET_ASSET_STATS = 'RESET_ASSET_STATS';
export const FETCH_ASSET_PRICE_HISTORY = 'FETCH_ASSET_PRICE_HISTORY';
export const RESET_ASSET_PRICE_HISTORY = 'RESET_ASSET_PRICE_HISTORY';
export const FETCH_ASSET_HISTORY = 'FETCH_ASSET_HISTORY';
export const APPEND_ASSET_HISTORY = 'APPEND_ASSET_HISTORY';
export const RESET_ASSET_HISTORY = 'RESET_ASSET_HISTORY';
export const RESET_STATS = 'RESET_STATS';
